<template lang="pug">
  v-container
    v-row
      v-col.text-center
        v-btn(
          @click="$createOnClick({ goToWhyYako })"
          color="primary"
          rounded
          large) Pourquoi utiliser Yako ?
    v-form(v-model="form")
      v-row
        v-col
          v-text-field(
            v-model="name"
            :rules="[value => !!value || `Le nom est requis.`, $createLengthRule({ max: 20, label: `Le nom` })]"
            label="Nom de la campagne d'annonce"
            :counter="20"
            filled)
      v-row
        v-col
          v-text-field(
            v-model="endingMessage"
            :rules="[$createLengthRule({ max: 80, label: `Le message de fin d'annonce` })]"
            label="Message de fin d'annonce"
            :counter="80"
            filled)
      v-row
        v-col
          input-url(
            v-model="endingUrl"
            :rules="[$createLengthRule({ max: 200, label: `L'URL` })]"
            :counter="200"
            label="Lien de fin d'annonce"
            hint="Ce lien est proposé au viewer à la fin du visionnage de votre annonce."
            filled)
      v-row
        v-col
          input-image(
            v-model="file"
            :image-height="200"
            fill-width
            :rules="rulesFileInput"
            required
            :label="`Fichier ${typeLabel}`"
            filled
            :accept="accept") 
      v-row
        v-col
          input-money(
            v-model="price"
            :rules="[() => price > 0 || `Le prix est requis.`, () => price >= 300 || `Le prix doît être supérieur à 3€`]"
            required
            :label="isAdmin ? `Prix reversé aux assos` : `Prix de la diffusion`"
            filled)
      v-row
        v-col(v-if="!isAdmin")
          v-text-field(
            :value="viewsCountTotal"
            label="Nombre de visionnages "
            type="Number"
            :disabled="!isAdmin"
            filled)
        v-col(v-else)
          v-text-field(
            v-model.number="viewsCountTotalAdminSet"
            :rules="[value => !!value || `Champs requis.`]"
            label="Nombre de visionnages"
            type="Number"
            filled)
      v-row
        v-col
          v-btn(
            @click="sorry"
            color="primary"
            block
            outlined) Cibler une catégorie de public
      v-row(v-if="isAdmin")
        v-col
          v-alert(
            :color="$theme.background.color"
            type="info") Vous êtes admin, la publication est gratuite !
</template>

<script>
import { page, injectRouteState } from '@iez/core'
import router, { routeCurrent } from '@iez/core/router/'
import { computed, reactive, toRefs, ref } from '@vue/composition-api'
import InputMoney from '@iez/components/inputs/money/'
import data from '@iez/lib/data/'
import waitFor from '@iez/lib/wait-for/'
import InputUrl from '@iez/components/inputs/url/'
import InputVideo from '@iez/components/inputs/video/'
import InputImage from '@iez/components/inputs/image/'
import createOnClick from '@iez/lib/create-on-click/'
import superhero from '@iez/illustrations/Superhero'
import IllustrationState from '@iez/components/illustration-state/'

export default {
  components: {
    IllustrationState,
    InputMoney,
    InputUrl,
    InputVideo,
    InputImage
  },

  setup () {
    const me = data.me({
      fields: [
        `id`,
        `isAdmin`
      ]
    })

    const viewsCountTotalAdminSet = ref(1)

    const isAdmin = computed(() => !!me.value?.isAdmin)

    const duration = computed(
      () => routeState?.file?.duration
    )

    const type = routeCurrent.params.type

    const payload = {
      isAdmin: false,
      name: ``,
      endingMessage: ``,
      kodonMessage: ``,
      endingUrl: ``,

      file: null,
      price: undefined,
      type,


      pricePerView: computed(
        () => !isAdmin.value
          ? 2
          : routeState.price / viewsCountTotalAdminSet.value
      ),

      viewsCountTotal: computed(
        () => isAdmin.value
          ? viewsCountTotalAdminSet.value
          : Math.floor(
            routeState.price / routeState.pricePerView
          )
      )
    }
    const routeState = injectRouteState({
      payload
    })

    waitFor({
      dependencies: () => me.value,
      predicate: () => !!me.value
    }).then(me => {
      routeState.isAdmin = me.isAdmin
    })

    const state = reactive({
      form: null,

      ...toRefs(routeState),

      rulesFileInput: computed(
        () => [
          value => !!value || `Le fichier est requis.`
        ].filter(Boolean)
        /*? type = `ko-don`
        : value => superhero */
      ),
      accept: `image/*`,
      typeLabel: `affiche`,
      topBarTitle: `Ajout affiche publicitaire`
    })

    page.topBar.set({
      title: computed(() => state.topBarTitle)
    })

    page.bottomAction.set(
      () => state.form
        ? ({
          action: {
            label: `Valider`,
            onClick: createOnClick({
              validate: () => {
                /*routeCurrent.params.type === `ko-don`
                ? value=`superhero`*/
                if (isAdmin.value) {
                  page.confirm({
                    title: `Es-tu sûr ?`,
                    content: `Cela va créer une campagne gratuitement.`,
                    callback: () => {
                      router.push({
                        name: `AddUploading`
                      })
                    }
                  })
                } else {
                  router.push({
                    name: `AddPayment`
                  })
                }
              }
            })
          }
        }) : null
    )
    const sorry = () => {
      page.blockingDialog.set({
        title: `Essayez ultérieurement`,
        content: `Cette fonctionnalité n'est pas disponible pour le moment. Nous travaillons d'arrache-pied pour son arrivée prochaine. Merci de votre compréhension.`,
        action1: {
          label: `Fermer`,
          onClick: () => {
            page.blockingDialog.unset()
          }
        }
      })
    }

    const percent = () => {
      page.blockingDialog.set({
        title: ` Merci pour votre soutien ! `,
        content: `Les 5% restants permettent de financer le service de paiement sécurisé ainsi que notre plateforme. Nous travaillons très dur pour que prochainement, 100% du montant soit redistribué aux associations sous forme de dons gratuits.`,
        action1: {
          label: `Compris`,
          onClick: () => {
            page.blockingDialog.unset()
          }
        }
      })
    }

    const goToWhyYako = () => {
      open(`https://yako.co/annonceur/`, `_blank`).focus()
    }

    return {
      ...toRefs(state),
      isAdmin,
      sorry,
      percent,
      superhero,
      //appendImageKodon,
      goToWhyYako,
      viewsCountTotalAdminSet,
      routeState,
      duration
    }
  }
}
</script>
